import Offer from './Offer'
import BookingType from './BookingType';

export default class Venue {
    id: string
    name: string
    buildingName: string
    street: string
    city: string
    postcode: string
    tags: any[]
    offers: Offer[] = []
    crossSellableTypes: string[] = []
    venueGroupId: string
    openingTimes: any[] = []

    static isValid (venue: {[index in string]: any}): boolean {
        return venue.hasOwnProperty('_id')
    }

    isTypeCrossSellable (type: BookingType): boolean {
        return this.crossSellableTypes.indexOf(type.id) > -1;
    }

    constructor (data: any) {
        this.id = data._id
        this.name = data.title
        this.buildingName = data.building_name
        this.street = data.street
        this.city = data.city
        this.postcode = data.postcode
        this.tags = data.booking_tags
        this.venueGroupId = data.venue_group
        this.openingTimes = data.opening_times

        if (data.offers) {
            data.offers.forEach((offer: any) => {
                this.offers.push(
                    new Offer(offer)
                )
            })
        }

        const crossSellableTypes = data.booking_types?.length ? data.booking_types.filter((type: any) => {
            return type.enable_cross_sell;
        }) : [];

        this.crossSellableTypes = crossSellableTypes.map((type: any) => type.id);
    }

    get address (): string {
        let address = ''

        if (this.buildingName) address += this.buildingName + ' '
        if (this.street) address += this.street + ', '
        if (this.city) address += this.city + ', '
        if (this.postcode) address += this.postcode

        return address
    }
}



// WEBPACK FOOTER //
// ./src/models/Venue.ts